<div class="rs-panel-big rs-bg-c2">
  <div class="rs-flex-row" *ngFor="let section of sections">
    <div class="rs-flex-column">
      <p class="rs-txt-primary">
        <strong>{{ section.labelKey | translate }}</strong>
      </p>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <p class="rs-font-pxB">{{ section.amount }}</p>
    </div>
  </div>
</div>
<div
  class="panel rs-bg-primary rs-margin-bottom2-s rs-margin-bottom4-m"
  my-bill-odb-total
  [amount]="totalAmount"
></div>
